import { CoreOperation } from "../../core/index.js";
import * as PSM from "../data-psm-vocabulary.js";
export class DataPsmDeleteContainer extends CoreOperation {
    static TYPE = PSM.DELETE_CONTAINER;
    dataPsmOwner = null;
    dataPsmContainer = null;
    constructor() {
        super();
        this.types.push(DataPsmDeleteContainer.TYPE);
    }
    static is(resource) {
        return resource?.types.includes(DataPsmDeleteContainer.TYPE);
    }
}
//# sourceMappingURL=data-psm-delete-container.js.map